var ListItem = (function () {
    function ListItem() {
    }
    return ListItem;
}());
export { ListItem };
var MyException = (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());
export { MyException };
//# sourceMappingURL=multiselect.model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/angular2-multiselect-dropdown/multiselect.model.js
// module id = 547
// module chunks = 3